import { Spinner } from "@/components/kit";
import { useAdminQuery } from "@/hooks/queries";
import { fmtDateTime } from "@/lib/toto";
import { AdminHeader, AdminTable, Badge } from "@/pages/admin/AdminLayout";

const toneFor = (a = "") => (/suspend|revoke|delete/.test(a) ? "danger" : /grant|create|activate/.test(a) ? "success" : /login/.test(a) ? "brand" : "neutral");

export default function AdminAudit() {
  const q = useAdminQuery("/admin/audit-logs");
  return (
    <>
      <AdminHeader title="Audit Logs" sub={q.data ? `${q.data.total} admin actions recorded` : ""} />
      {q.isLoading ? <Spinner /> : (
        <AdminTable testid="admin-audit-table" rows={q.data?.items ?? []} cols={[
          { label: "When", render: (l) => fmtDateTime(l.createdAt) }, { label: "Admin", k: "adminEmail" },
          { label: "Action", render: (l) => <Badge tone={toneFor(l.action)}>{l.action}</Badge> }, { label: "Target", render: (l) => `${l.targetType || "—"} ${l.targetId ? `· ${String(l.targetId).slice(-6)}` : ""}` },
          { label: "Detail", render: (l) => <span className="block max-w-[320px] truncate text-[#64748B]">{l.detail && Object.keys(l.detail).length ? JSON.stringify(l.detail) : "—"}</span> },
        ]} empty="No audit entries yet." />
      )}
    </>
  );
}
